import { useState } from 'react';
import './ContactSection.css';
import underlineImg from '../assets/underline.png';
import { IconLightning } from './Icons';

const INFO_ITEMS = [
  {
    label: 'Email Us',
    value: 'info@madmarketingclub.com',
    href: 'mailto:info@madmarketingclub.com',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="3"/>
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
      </svg>
    ),
  },
  {
    label: 'WhatsApp',
    value: '+91 95274 20924',
    href: 'https://wa.me/919527420924',
    external: true,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
    ),
  },
  {
    label: 'Location',
    value: 'Pune, Maharashtra, India',
    href: 'https://maps.google.com/?q=Pune,Maharashtra,India',
    external: true,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
  },
  {
    label: 'Office Hours',
    value: 'Mon – Sat, 10am – 7pm IST',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
  },
];

const SOCIALS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/madandaaz/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/mad-marketing-club?originalSubdomain=in',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
        <rect x="2" y="9" width="4" height="12"/>
        <circle cx="4" cy="4" r="2"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/p/Mad-Marketing-Club-61573772583596/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCyhGXurSsD-obd6hpxUChLg',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
];

const SERVICES = [
  { group: 'E-Commerce & Marketplaces', options: [
    'Amazon / Marketplace Management',
    'Shopify / D2C Store Development',
    'Quick Commerce (Blinkit / Zepto / Swiggy)',
    'International Marketplace Expansion',
    'Multi-Channel Selling Setup',
  ]},
  { group: 'Marketing & Growth', options: [
    'Performance Marketing (Google / Meta PPC)',
    'SEO & Content Strategy',
    'Social Commerce & Influencer Marketing',
    'Email & WhatsApp Marketing',
    'Brand Strategy & Positioning',
  ]},
  { group: 'Carrier & Logistics', options: [
    'Shipping & Carrier Integration',
    'Warehouse & Fulfillment Setup',
    'Returns Management',
    'Last-Mile Delivery Optimization',
  ]},
  { group: 'Other', options: [
    'Career / Job Inquiry',
    'Partnership / Collaboration',
    'General Query',
  ]},
];

const BUDGETS = [
  'Under ₹25,000 / month',
  '₹25,000 – ₹75,000 / month',
  '₹75,000 – ₹2,00,000 / month',
  '₹2,00,000+ / month',
  'Not sure yet',
];

const REFERRALS = [
  'Google Search',
  'Instagram / Social Media',
  'LinkedIn',
  'YouTube',
  'Friend / Colleague Referral',
  'Blog / Article',
  'Other',
];

const EMPTY_FORM = { name: '', email: '', phone: '', service: '', budget: '', referral: '', message: '' };

export default function ContactSection() {
  const [form, setForm]       = useState(EMPTY_FORM);
  const [status, setStatus]   = useState('idle'); // idle | sending | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');

    const payload = new FormData();
    payload.append('name',     form.name);
    payload.append('email',    form.email);
    payload.append('phone',    form.phone    || '');
    payload.append('service',  form.service  || '');
    payload.append('budget',   form.budget   || '');
    payload.append('referral', form.referral || '');
    payload.append('message',  form.message);

    try {
      const res  = await fetch('/api/contact.php', { method: 'POST', body: payload });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setErrorMsg(data.message || 'Something went wrong. Please try again.');
        setStatus('error');
      }
    } catch {
      setErrorMsg('Network error. Please check your connection and try again.');
      setStatus('error');
    }
  };

  const reset = () => { setForm(EMPTY_FORM); setStatus('idle'); setErrorMsg(''); };

  return (
    <section className="cs-section">
      <div className="cs-header">
        <div className="badge cs-badge">
          <span className="badge-icon"><IconLightning /></span>
          GET IN TOUCH
        </div>
        <h2 className="cs-title">
          Let's build something
          <span className="cs-title-gradient"> remarkable</span>
        </h2>
        <img src={underlineImg} alt="" className="cs-underline" />
        <p className="cs-subtitle">
          Tell us about your brand and goals. Our team will get back within 24 hours.
        </p>
      </div>

      <div className="cs-body">

        {/* LEFT — info panel */}
        <div className="cs-left">
          <div className="cs-info-card">
            <p className="cs-info-intro">
              We're a Pune-based growth partner for e-commerce brands.
              Whether you're launching, scaling, or dominating — we're ready to talk.
            </p>

            <div className="cs-info-list">
              {INFO_ITEMS.map(item => (
                <div key={item.label} className="cs-info-item">
                  <div className="cs-info-icon">{item.icon}</div>
                  <div className="cs-info-text">
                    <span className="cs-info-label">{item.label}</span>
                    {item.href ? (
                      <a
                        className="cs-info-value cs-info-link"
                        href={item.href}
                        target={item.external ? '_blank' : undefined}
                        rel={item.external ? 'noopener noreferrer' : undefined}
                      >
                        {item.value}
                      </a>
                    ) : (
                      <span className="cs-info-value">{item.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="cs-divider" />

            <div className="cs-socials-row">
              <span className="cs-socials-label">Follow us</span>
              <div className="cs-socials">
                {SOCIALS.map(s => (
                  <a
                    key={s.label}
                    href={s.href}
                    className="cs-social-btn"
                    aria-label={s.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — form */}
        <div className="cs-right">
          {status === 'success' ? (
            <div className="cs-success">
              <div className="cs-success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                  stroke="#4f46e5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h3 className="cs-success-title">Message sent!</h3>
              <p className="cs-success-desc">
                Thanks, <strong>{form.name}</strong>. We'll be in touch within 24 hours.
              </p>
              <button className="cs-submit" onClick={reset}>Send Another</button>
            </div>
          ) : (
            <form className="cs-form" onSubmit={handleSubmit} noValidate>

              {/* Row 1: name + email */}
              <div className="cs-form-row">
                <div className="cs-field">
                  <label className="cs-label" htmlFor="cs-name">Full Name *</label>
                  <input
                    id="cs-name" name="name" type="text" className="cs-input"
                    placeholder="Ashay Jinturkar"
                    value={form.name} onChange={handleChange} required
                  />
                </div>
                <div className="cs-field">
                  <label className="cs-label" htmlFor="cs-email">Email Address *</label>
                  <input
                    id="cs-email" name="email" type="email" className="cs-input"
                    placeholder="you@brand.com"
                    value={form.email} onChange={handleChange} required
                  />
                </div>
              </div>

              {/* Row 2: phone + service */}
              <div className="cs-form-row">
                <div className="cs-field">
                  <label className="cs-label" htmlFor="cs-phone">Phone / WhatsApp</label>
                  <input
                    id="cs-phone" name="phone" type="tel" className="cs-input"
                    placeholder="+91 98765 43210"
                    value={form.phone} onChange={handleChange}
                  />
                </div>
                <div className="cs-field">
                  <label className="cs-label" htmlFor="cs-service">Service / Query Type</label>
                  <select
                    id="cs-service" name="service"
                    className="cs-input cs-select"
                    value={form.service} onChange={handleChange}
                  >
                    <option value="">Select a service…</option>
                    {SERVICES.map(({ group, options }) => (
                      <optgroup key={group} label={group}>
                        {options.map(o => <option key={o} value={o}>{o}</option>)}
                      </optgroup>
                    ))}
                  </select>
                </div>
              </div>

              {/* Row 3: budget + referral */}
              <div className="cs-form-row">
                <div className="cs-field">
                  <label className="cs-label" htmlFor="cs-budget">Monthly Budget</label>
                  <select
                    id="cs-budget" name="budget"
                    className="cs-input cs-select"
                    value={form.budget} onChange={handleChange}
                  >
                    <option value="">Select budget range…</option>
                    {BUDGETS.map(b => <option key={b} value={b}>{b}</option>)}
                  </select>
                </div>
                <div className="cs-field">
                  <label className="cs-label" htmlFor="cs-referral">How Did You Hear About Us?</label>
                  <select
                    id="cs-referral" name="referral"
                    className="cs-input cs-select"
                    value={form.referral} onChange={handleChange}
                  >
                    <option value="">Select an option…</option>
                    {REFERRALS.map(r => <option key={r} value={r}>{r}</option>)}
                  </select>
                </div>
              </div>

              {/* Message */}
              <div className="cs-field cs-field--full">
                <label className="cs-label" htmlFor="cs-message">Tell Us About Your Brand *</label>
                <textarea
                  id="cs-message" name="message"
                  className="cs-input cs-textarea"
                  placeholder="Describe your brand, current challenges, and what you're looking to achieve…"
                  rows={5}
                  value={form.message} onChange={handleChange} required
                />
              </div>

              {/* Error banner */}
              {status === 'error' && (
                <div className="cs-error">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {errorMsg}
                </div>
              )}

              <div className="cs-form-footer">
                <button
                  type="submit"
                  className={`cs-submit${status === 'sending' ? ' cs-submit--loading' : ''}`}
                  disabled={status === 'sending'}
                >
                  {status === 'sending' ? (
                    <>
                      <span className="cs-spinner" />
                      Sending…
                    </>
                  ) : (
                    <>
                      Send Message
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"/>
                        <polyline points="12 5 19 12 12 19"/>
                      </svg>
                    </>
                  )}
                </button>

                <p className="cs-privacy">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  Your information is private and will never be shared.
                </p>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
